export enum ViewModes {
  List,
  Floormap,
}
